// extracted by mini-css-extract-plugin
module.exports = {"container":"NotAcceptingPurchase_container__yaVj4","errorMessage":"NotAcceptingPurchase_errorMessage__yBkCz","buttonSection":"NotAcceptingPurchase_buttonSection__gafSB"};